export default __webpack_public_path__ + "static/pulse_dashboard-9648aee7e43398e03ce5de089c4c6cbd.jpeg";